import "../CSS/formAgregarEvento.css";
import IncrementadorNum from "./IncrementadorNum";
import React, { useRef, useEffect, useState, Fragment } from "react";
import NavBar from "./NavBar";

import { storage } from "../FirebaseConfig/firebase";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import LinearProgress from "@mui/material/LinearProgress";
import { collection, addDoc } from "firebase/firestore";
import { db } from "../FirebaseConfig/firebase";
import { useNavigate } from "react-router-dom";
import TextField from "@mui/material/TextField";
import dayjs from "dayjs";
import Stack from "@mui/material/Stack";

import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";

const MySwal = withReactContent(Swal);

function AgregarComunicado() {
  const eventosList = collection(db, "EVENTOS");
  const navigate = useNavigate();
  const imagen = "../img/";
  const handleChange = (newValue) => {
    setFecha(newValue);
    setFechaString(dayjs(newValue).format("YYYY-MM-DD HH:mm:ss"));
  };

  const [maxAsientos, setMaxAsientos] = useState("0");
  const [estado, setEstado] = React.useState("");
  const [salon, setSalon] = React.useState("");
  const [nombre, setNombre] = React.useState("");
  const [fecha, setFecha] = React.useState("");
  const [fechaString, setFechaString] = useState("");

  const [imagenLocal, setImagenLocal] = useState("imagen.png");
  const [tipoEvento, setTipoEvento] = useState("");

  const [descripcion, setDescripcion] = React.useState("");
  const [urlImagen, setUrlImage] = useState("");
  const [pbVisible, setpbVisible] = useState(false);
  const [editarVisible, setEditarVisible] = useState(false);

  const handleChangeSa = (event) => {
    setSalon(event.target.value);
    if (event.target.value == "Salon de eventos") {
      setMaxAsientos("10");
      setEditarVisible(true);
    } else {
      setEditarVisible(false);
    }
  };
  const handleChangeEs = (event) => {
    setEstado(event.target.value);
  };
  const handleChangeTE = (event) => {
    setTipoEvento(event.target.value);
  };
  const validarFormulario = (e) => {
	console.log("Validas");

    if (
      nombre == "" ||
      descripcion == "" ||
      salon == "" ||
      fecha == "" ||
      estado == "" ||
      tipoEvento == "" ||
      maxAsientos == "0"
    ) {
      MySwal.fire("", "Llenar todos los campos", "error");
    } else {
      if (urlImagen == "") {
        MySwal.fire("", "Subir imagen ", "error");
      } else {
        store(e);
      }
    }
  };
  const editarEscenario = () => {
    console.log("EDITAR ESCENARIO");
    navigate("../panelAdmin/eventos/agregarEvento/editarEscenario");
  };
  const archivoHandler = (e) => {
    const archivo = e.target.files[0];
    setpbVisible(true);
    var today = new Date();
    var prefijoImagen =
      today.getDate().toString() +
      today.getHours().toString() +
      today.getMinutes().toString() +
      today.getSeconds().toString();

    const storageRef = ref(
      storage,
      "imagenesEventos/" + prefijoImagen + archivo.name
    );

    uploadBytes(storageRef, archivo).then((snapshot) => {
      setpbVisible(false);

      const storage = getStorage();
      getDownloadURL(
        ref(storage, "imagenesEventos/" + prefijoImagen + archivo.name)
      )
        .then((url) => {
          setUrlImage(url);
          console.log("URL " + url);
          const xhr = new XMLHttpRequest();
          xhr.responseType = "blob";
          xhr.onload = (event) => {
            setpbVisible(false);

            const blob = xhr.response;
          };
          xhr.open("GET", url);
          xhr.send();
          // Or inserted into an <img> element
          const img = document.getElementById("imagenTienda");
          img.setAttribute("src", url);
        })
        .catch((error) => {
          console.log("error " + error);
        });
    });
  };

  const store = async (e) => {
    e.preventDefault();

    MySwal.fire({
      title: "Agregar evento? ",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, Agregar",
    }).then(async (result) => {
      if (result.isConfirmed) {
        await addDoc(eventosList, {
          descripcion: descripcion,
          estado: estado,
          urlImagen: urlImagen,
          nombre: nombre,
          salon: salon,
          fecha: fechaString,
          maxAsientos: maxAsientos,
          tipoEvento: tipoEvento,
        }).then(async (docRef) => {
          Swal.fire("Agregado", "El evento ha sido creado", "success");
          if (salon == "Auditorio Paulet") {
			navigate(`../panelCDA/eventos/`);

          }
          if (salon == "Salon de eventos") {
            navigate(`../panelAdmin/eventos/agregarEvento/${docRef.id}`);
          }
        });
      }
    });
  };
  //cerrar agregar evento
  const cerrar = () => {
    navigate("../panelCDA/eventos");
  };

  return (
    <Fragment>
      <NavBar
        titulo="Agregar evento"
        imagen="cerrar"
        logoTitulo="eventos"
        cerrar={cerrar}
      ></NavBar>
      <div className="asd">
        <div className="grid-container">
          <div className="grid-item">
            <div className="divImagen">
              <div className="image-upload">
                <label htmlFor="file-input">
                  <img
                    id="imagenTienda"
                    src={require(`../img/${imagenLocal}`)}
                    alt="logo-titulo"
                    className="imagenEmpresa"
                  />
                </label>
                <input
                  className="btnAgrearImagenEvento"
                  id="file-input"
                  accept="image/png, image/jpeg, image/jpg"
                  type="file"
                  onChange={archivoHandler}
                />
              </div>
              {pbVisible ? (
                <LinearProgress color="success" style={{ marginBottom: 20 }} />
              ) : null}
            </div>

            <div className="formNumber">
              <Box sx={{ width: 300 }}>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">Salon</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={salon}
                    label="Salon"
                    onChange={handleChangeSa}
                  >
                    <MenuItem value={"Auditorio Paulet"}>
                      Auditorio Paulet
                    </MenuItem>
                    <MenuItem value={"Salon de eventos"}>
                      Salon de eventos
                    </MenuItem>
                  </Select>
                </FormControl>
              </Box>
            </div>

            <div className="formNumber">
              <Box sx={{ width: 300 }}>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">Estado</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={estado}
                    label="Estado"
                    onChange={handleChangeEs}
                  >
                    <MenuItem value={"Activo"}>Activo</MenuItem>
                    <MenuItem value={"Inactivo"}>Inactivo</MenuItem>
                  </Select>
                </FormControl>
              </Box>
            </div>
            <div className="formNumber">
              <Box sx={{ width: 300 }}>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">
                    Tipo de evento
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={tipoEvento}
                    label="Tipo de Evento"
                    onChange={handleChangeTE}
                  >
                    {salon == "Auditorio Paulet" ? (
                      <MenuItem value={"Gratuito"}>Gratuito</MenuItem>
                    ) : null}
                    {salon == "Auditorio Paulet" ? (
                      <MenuItem value={"Pago"}>Pago</MenuItem>
                    ) : (
                      <MenuItem value={"Pago (con comida)"}>
                        Pago (con comida)
                      </MenuItem>
                    )}

                    {salon == "Auditorio Paulet" ? (
                      <MenuItem value={"Mixto"}>Mixto</MenuItem>
                    ) : (
                      <MenuItem value={"Pago (sin comida)"}>
                        Pago (sin comida)
                      </MenuItem>
                    )}

                    {salon == "Auditorio Paulet" ? (
                      <MenuItem value={"Colegiatura"}>Colegiatura</MenuItem>
                    ) : null}
                  </Select>
                </FormControl>
              </Box>
            </div>
          </div>
          <div className="grid-item">
            <div className="formulario-derecha-contenedor">
              <div className="formulario-derecha-contenido">
                <div className="form-derecha">
                  <form action="/" className="form">
                    <label className="label">Nombre del evento</label>
                    <textarea
                      type="text"
                      id="descripcion"
                      maxLength="200"
                      placeholder="Máximo 200 caracteres."
                      className="input input-descripcion"
                      value={nombre}
                      onChange={(e) => setNombre(e.target.value)}
                    />
                    <label className="label">Descripción del evento</label>
                    <textarea
                      style={{ height: "200px" }}
                      type="text"
                      id="descripcion"
                      maxLength="200"
                      placeholder="Máximo 200 caracteres."
                      className="input input-descripcion"
                      value={descripcion}
                      onChange={(e) => setDescripcion(e.target.value)}
                    />
                  </form>

                  <label className="label">Fecha del evento</label>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <Stack spacing={3}>
                      <DateTimePicker
                        value={fecha}
                        onChange={handleChange}
                        renderInput={(params) => <TextField {...params} />}
                      />
                    </Stack>
                  </LocalizationProvider>
                </div>
                {!editarVisible ? (
                  <div className="formNumber">
                    <label className="label" style={{ marginRight: "40px" }}>
                      Asientos permitidos
                    </label>
                    <IncrementadorNum
                      style={{ margin: "30px" }}
                      contador={maxAsientos}
                      setContador={setMaxAsientos}
                    ></IncrementadorNum>
                  </div>
                ) : null}

                <div className="agregarEvento">
                  <input
                    type="submit"
                    value={!editarVisible ? "Agregar Evento" : "Editar Mesas"}
                    onClick={validarFormulario}
                    className="btnAgregarComunicado"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
}

export default AgregarComunicado;
